module.exports = __webpack_public_path__ + "static/media/Batteries_Heavyduty_xparent.8c118657.png";